var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11321",
    "data-name": "Path 11321",
    d: "M17.538,29.692a.663.663,0,0,1-.15,0C16.777,29.508,6,23.808,6,18.154V7.192a.577.577,0,0,1,.577-.577c2.625,0,9.577-3.069,10.494-4.373A.577.577,0,0,1,17.538,2h0a.577.577,0,0,1,.473.242c.9,1.275,7.546,4.373,10.488,4.373a.577.577,0,0,1,.577.577V18.731c0,4.673-10.881,10.8-11.388,10.962A.663.663,0,0,1,17.538,29.692ZM7.154,7.769V18.154c0,4.327,8.654,9.577,10.385,10.333,1.488-.715,10.385-6.213,10.385-9.756V7.769A25.091,25.091,0,0,1,17.538,3.437C15.64,5.063,10.038,7.423,7.154,7.769Z",
    transform: "translate(-2.538 -0.846)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11322",
    "data-name": "Path 11322",
    d: "M18.671,28.273h0a.617.617,0,0,1-.41-.179l-5.094-5.262a.577.577,0,0,1,0-.813l2.308-2.308a.577.577,0,0,1,.819,0L18.769,22.2l7.1-7.021a.577.577,0,0,1,.813,0l2.308,2.308a.577.577,0,0,1,0,.819l-9.9,9.808A.577.577,0,0,1,18.671,28.273ZM14.384,22.44l4.3,4.437,9.075-8.988L26.269,16.4l-7.1,7.021a.577.577,0,0,1-.813,0l-2.475-2.475Z",
    transform: "translate(-5.5 -6.35)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3813",
    "data-name": "Rectangle 3813",
    width: 30,
    height: 30,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordInactive);
export default __webpack_public_path__ + "static/media/password-inactive.5ee3b33b106ff903ae5a9ffc74d07416.svg";
export { ForwardRef as ReactComponent };